import type { ColumnDef, OnChangeFn, SortingState } from '@tanstack/react-table'

export enum TableListStaticColumnsEnum {
  DETAILS = 'DETAILS',
  ICON = 'ICON',
}

export interface TableProps<T> {
  columns: ColumnDef<T>[]
  data: T[]
  e2eRowId: string
  className?: string
  isLoading?: boolean
  isSearching?: boolean
  hideArrow?: boolean
  onSortingChange?: OnChangeFn<SortingState>
  sorting?: SortingState
  selectedRowIndex?: string | number | null
  customNoResultsMessage?: string
  withSubrows?: boolean
}
